import { Controller } from "stimulus";

// Conecta este controlador a <div data-controller="legacy-password-reset">
export default class extends Controller {
  static targets = ["modal"];

  hide() {
    this.modalTarget.classList.add("hidden");
  }
}
